import { rootApi } from "../user/api";

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ["StatusCheck"],
});

export const StatusCheckListApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findInitData: builder.mutation({
      query: () => `status_check/`,
      keepUnusedDataFor: 0,
      providesTags: ["StatusCheck"],
    }),

    postSelectData: builder.mutation({
      query: (plan_job_id) => `status_check/final_confirm/${plan_job_id}/`,
      keepUnusedDataFor: 0,
      providesTags: ["StatusCheck"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFindInitDataMutation, usePostSelectDataMutation } =
  StatusCheckListApi;
